<div class="inline-flex flex-col gap-4 min-w-40 h-full p-3 justify-between border rounded" [ngClass]="highlightBackgroundClass">
  <div class="flex flex-col gap-1">
    <p class="m-0 text-xs font-semibold leading-none " [ngClass]="highlightTextClass">
      {{ groupTitle }}
    </p>
    <p class="mb-0 leading-none">
      {{title}}
    </p>
  </div>

  <div class="flex flex-col">
    <div class="relative flex flex-row gap-2 justify-between items-center">
      <h3 class=" mb-0 text-lg font-semibold leading-none">{{value || 0 }}</h3>
      <div
        class="flex flex-row items-center rounded p-[2px] gap-2 leading-none"
        [ngClass]="trend ? 'bg-green-50' : 'bg-red-50'"
        *ngIf="percentageDifference">
        <span class="mb-0 font-semibold leading-none " [ngClass]="trend ? 'text-brand-green' : 'text-brand-red '">
          {{percentageDifference}}%
        </span>
      </div>
    </div>

    <div class="flex h-4 items-end min-h-4">
      <p class="mb-0 text-sm text-gray-800 leading-none" *ngIf="description">{{description}}</p>
    </div>
  </div>
</div>
